import {
  Component,
  forwardRef,
  ViewChild,
  HostListener,
  DoCheck
} from "@angular/core";
import { InputBase } from "../input-base";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BsDatepickerDirective } from "ngx-bootstrap/datepicker";
import { DateTimepicker } from "@tmhcc-ng-lib/framwork/form-inputs";

@Component({
    selector: "hcc-datepicker-custom-input",
    templateUrl: "./date-picker-custom.component.html",
    styleUrls: ['./date-picker-custom.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatePickerCustomComponent),
            multi: true
        }
    ],
    standalone: false
})
export class DatePickerCustomComponent extends InputBase<string> implements DoCheck {
  datepickerConfig!: DateTimepicker;
  displayDateFormat = "MM/dd/yyyy";
  isCalanderOpen = false;
  private isNormalizingDate = false;
  selectedDate: Date | null = null;
  selectedHour = 0;
  readonly hourOptions: number[] = Array.from({ length: 24 }, (_, hour) => hour);
  @ViewChild("dp", { static: false })
  datepicker!: BsDatepickerDirective;
  myDateValue: Date = new Date();
  // @Input() isDatePicker: boolean = true;
  @HostListener("window:scroll")
  onScrollEvent() {
    if (
      this.InputConfig != null &&
      this.InputConfig.hasOwnProperty("datePickerConfig") &&
      this.InputConfig.datePickerConfig.hasOwnProperty("hideOnScroll")
    ) {
      if (this.InputConfig.datePickerConfig.hideOnScroll) {
        this.datepicker.hide();
      }
    }
  }

  ngDoCheck() {
    this.ensureDatePickerConfig();
    this.syncDateSelectionFromControl();

    if (
      this.InputConfig.datePickerConfig.hasOwnProperty("isCalanderRequired")
    ) {
      if (
        !this.InputConfig.datePickerConfig.isCalanderRequired &&
        this.datepicker
      ) {
        this.datepicker.hide();
      }
    }
  }

  onChange(event: Date | null): void {
    if (!event || this.isNormalizingDate) {
      return;
    }

    this.selectedDate = new Date(event);
    this.applyDateWithFixedMinutes();
    this.isCalanderOpen = false;
  }

  onHourChange(event: Event): void {
    const selectedValue = Number((event.target as HTMLSelectElement).value);
    this.selectedHour = this.normalizeHour(selectedValue);
    this.applyDateWithFixedMinutes();
  }

  private applyDateWithFixedMinutes(): void {
    if (!this.selectedDate) {
      return;
    }

    const normalized = new Date(this.selectedDate);
    normalized.setHours(this.selectedHour, 0, 0, 0);
    const control = this.frmGroup.get(this.fieldInfo.fieldName);
    this.isNormalizingDate = true;
    control?.setValue(normalized, { emitEvent: false });
    this.isNormalizingDate = false;
  }

  constructor() {
    super();
  }

  private ensureDatePickerConfig(): void {
    const config = this.InputConfig?.datePickerConfig as DateTimepicker | undefined;

    if (!config || this.datepickerConfig) {
      return;
    }

    const dateOnlyFormat = this.getDateOnlyFormat(config.dateInputFormat as string);
    this.displayDateFormat = this.toAngularDateFormat(dateOnlyFormat);

    this.datepickerConfig = {
      isAnimated: config.isAnimated,
      adaptivePosition: config.adaptivePosition,
      dateInputFormat: dateOnlyFormat,
      returnFocusToInput: config.returnFocusToInput,
      selectFromOtherMonth: config.selectFromOtherMonth,
      containerClass: config.containerClass || "theme-dark-blue",
      showWeekNumbers: config.showWeekNumbers,
      withTimepicker: false,
      keepDatepickerOpened: false
    } as DateTimepicker;
  }

  private syncDateSelectionFromControl(): void {
    if (!this.frmGroup || !this.fieldInfo?.fieldName) {
      return;
    }

    const controlValue = this.frmGroup.get(this.fieldInfo.fieldName)?.value;

    if (controlValue instanceof Date && !isNaN(controlValue.getTime())) {
      const hasDateChanged =
        !this.selectedDate || this.selectedDate.getTime() !== controlValue.getTime();

      if (hasDateChanged) {
        this.selectedDate = new Date(controlValue);
        this.selectedHour = this.normalizeHour(controlValue.getHours());
      }
      return;
    }

    this.selectedDate = null;
  }

  private normalizeHour(hour: number): number {
    if (isNaN(hour)) {
      return 0;
    }

    return Math.min(23, Math.max(0, hour));
  }

  private getDateOnlyFormat(format: string): string {
    if (!format) {
      return "MM/DD/YYYY";
    }

    if (format.includes("T")) {
      return format.split("T")[0].trim();
    }

    if (format.includes(" ")) {
      return format.split(" ")[0].trim();
    }

    return format.trim();
  }

  private toAngularDateFormat(format: string): string {
    return format
      .replace(/YYYY/g, "yyyy")
      .replace(/YY/g, "yy")
      .replace(/DD/g, "dd")
      .replace(/D/g, "d");
  }

  calanderClicked() {
    this.isCalanderOpen = !this.isCalanderOpen;
  }
}
